<template>
  <v-dialog v-model="open" width="70vw">
    <v-card class="pa-4">
      <p class="text-2xl ma-5 mb-9">
        {{ question }}
      </p>
      <v-row class="mx-1 my-3">
        <v-card-text>
          <v-form ref="confirmationForm">
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn
                  color="primary"
                  class="me-3 mt-3"
                  @click.native="$emit('confirm')"
                  >Confirmer
                </v-btn>
                <v-btn
                  color="secondary"
                  outlined
                  class="mt-3"
                  @click.native="$emit('cancel')"
                >
                  Annuler
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Confirm",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    question: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {

    // =>  METHODS

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {};
  },
};
</script>
